import script from "./TableListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TableListItem.vue?vue&type=script&setup=true&lang=js"

import "./TableListItem.vue?vue&type=style&index=0&id=2329f512&lang=scss"

export default script